// Update the ProductList component
import {AppContext} from "./../context/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import Card from 'react-bootstrap/Card';
import redBull from '../assets/images/redbull.png';
import noImage from '../assets/images/noimage.jpg';
import noProduct from '../assets/images/noproduct.jpg';
import {
    getWithAuthCallWithErrorResponse, PostCallWithErrorResponse, PutCallWithErrorResponse, simplePostCall
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import Loading from "../sharedComponents/Loaders/Loading";
import {notifyError, notifySuccess} from "../sharedComponents/notify";
import {useParams} from "react-router";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import BtnLoader from "../sharedComponents/Loaders/BtnLoader";

function ProductList() {
    const initialProduct = {
        machineId: 186,
        slotNo: "",
        invQty: Number(9),
        cargoQty: 0,
        verifyAge: true,
        minPurchaseAge: "",
        status: "",
        createdAt: "",
        updatedAt: "",
        isDeleted: true
    };

    interface Slot {
        slotNo: string;
        productName: string;
        quantity: number;
        price: number;
        productId: string;
        machineId: number;
        categoryId: string;
    }


    const {id} = useParams();
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    // const [product, setProduct] = useState({
    //     machineId: 186, slotNo: "", invQty: 0, cargoQty: 0, productCode: "", productName: ""
    // });
    const [selectedProductIndex, setSelectedProductIndex] = useState(-1);
    const {sidebar, count} = useContext(AppContext);
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(true);
    // const [productList, setProductList] = useState([]);
    const [validated, setValidated] = useState(false);
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [selectedProductId, setSelectedProductId] = useState("");
    const [machineId, setMachineId] = useState(null);
    const [vendingMachineName, setVendingMachineName] = useState("");
    const [slots, setSlots] = useState([]);
    const [totalSlot, setTotalSlot] = useState(0);
    const [showChangeModal, setShowChangeModal] = useState(false);
    const [quantityError, setQuantityError] = useState("");
    const [productNameError, setProductNameError] = useState("");
    const [isFormValid, setIsFormValid] = useState(false);
    const [slot, setSlot] = useState({
        slotNo: '', productName: '', quantity: 0, price: 0, productId: '', machineId: id, categoryId: ''
    });
    const rowRefs = useRef([]);
    const textRefs = useRef([]);
    const [maxHeights, setMaxHeights] = useState([]);
    const [maxTextHeights, setMaxTextHeights] = useState([]);
    const handleChangeModalClose = () => {
        setShowChangeModal(false);
        setSelectedCategoryId("");
        setSelectedProductId("");
    };
    const handleChangeModalShow = (slotResponse) => {
        if (!slotResponse) return;
        const categoryIdOfResponse = findCategoryId(slotResponse);
        setSelectedCategoryId(categoryIdOfResponse);
        setSelectedProductId(slotResponse.productId || "");
        getProducts(categoryIdOfResponse, true);
        setSlot(prevSlot => ({
            ...prevSlot,
            slotNo: slotResponse.slotNo || '',
            productName: slotResponse.productName || '',
            quantity: slotResponse.quantity || 0,
            price: slotResponse.price || 0,
            productId: slotResponse.productId || "",
            machineId: id,
            categoryId: categoryIdOfResponse
        }));
        setShowChangeModal(true);
        validateForm();
    };

    useEffect(() => {
        if (products.length > 0 && (!selectedProductId || !products.find(p => p.product_id === selectedProductId))) {
            setSelectedProductId(products[0].product_id);
            setSlot(prevSlot => ({
                ...prevSlot,
                productId: products[0].product_id
            }));
        }
    }, [products]);

    useEffect(() => {
        if (rowRefs.current.length > 0) {
            const newMaxHeights = rowRefs.current.map(row => {
                if (row) {
                    const cardHeights = Array.from(row.children).map(card => card.offsetHeight);
                    return Math.max(...cardHeights, 0);
                }
                return 0;
            });
            setMaxHeights(newMaxHeights);
        }

        if (textRefs.current.length > 0) {
            const newMaxTextHeights = textRefs.current.map(texts => {
                if (texts && texts.length > 0) {
                    const textHeights = texts.map(text => text.offsetHeight);
                    return Math.max(...textHeights, 0);
                }
                return 0;
            });
            setMaxTextHeights(newMaxTextHeights);
        }
    }, [slots]);


    const findCategoryId = (slotResponse) => {
        return slotResponse.categoryId ? slotResponse.categoryId : (categories.length > 0 ? categories[0].id : null);
    };

    const showFormDetails = (prod, index) => {
        PostCallWithErrorResponse(ApiConfig.GET_SLOT_DATA, {
            machineId: Number(id), slotNo: prod.slotNo, productId: prod.productId
        }).then((res) => {
            let data = res?.json?.data;
            if (res.json.success) {
                setSlot({
                    ...slot,
                    slotNo: data?.slotNo,
                    invQty: data?.invQty,
                    cargoQty: data?.cargoQty,
                    productCode: data?.productCode,
                    productName: data?.productName
                });
                setShowUpdateModal(true);
                setSelectedProductIndex(index);
            } else {
                notifyError("Something went wrong");
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const getProductList = () => {
        getWithAuthCallWithErrorResponse(ApiConfig.GET_VM_SLOT_INFO + `/${id}`).then((res) => {
            setLoading(false);
            if (!res || !res.json || !res.json.data) return;

            let slotsData = res.json.data;
            setTotalSlot(res.json.totalSlots || 0);
            setMachineId(res.json.machineId || null);
            setVendingMachineName(res.json.machineName || "");

            if (res.json.machineId) {
                setSlots(slotsData);
            } else {
                const allSlots = slotsData.flatMap(item => item.slots);
                const newData = [];
                for (let i = 0; i < allSlots.length; i += 6) {
                    newData.push({ slots: allSlots.slice(i, i + 6) });
                }
                setSlots(newData);
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    useEffect(() => {
        getCategories();
        getProductList();
    }, []);

    useEffect(() => {
        validateForm();
    }, [selectedProductId, slot, quantityError, productNameError]);

    const getCategories = () => {
        getWithAuthCallWithErrorResponse(ApiConfig.CATEGORIES)
            .then((res) => {
                let data = res.json;
                setCategories(data ? data.list : []);
            })
            .catch((err) => {
                setCategories([]);
                console.log(err);
            });
    };

    const getProducts = (categoryId) => {
        getWithAuthCallWithErrorResponse(`${ApiConfig.GET_PRODUCT}?category_id=${categoryId || ""}&size=1000`)
            .then((res) => {
                let data = res.json;
                if (data) {
                    let arr = [];
                    data.list.forEach((i) => {
                        i.product.product_id = i.id;
                        arr.push(i.product);
                    });
                    setProducts(arr);
                }
            })
            .catch((err) => {
                setProducts([]);
                console.log(err);
            });
    };

    const handleChange = (key, val) => {
        setSlot(prevSlot => ({
            ...prevSlot,
            [key]: val !== undefined ? val : ""
        }));
    };

    const updateSlot = () => {
        PutCallWithErrorResponse(ApiConfig.UPDATE_SLOT_DATA, slot).then((res) => {
            if (res.json.success) {
                notifySuccess("Submited Successfully");
                setShowUpdateModal(false);
                setSelectedProductIndex(-1);
            } else {
                notifyError("The Machine is Not connected please try again");
            }
        }).catch(err => console.log(err));
    };

    const handleCategoryChange = (e) => {
        const categoryIdEvent = e.target.value;
        setSelectedCategoryId(categoryIdEvent)
        getProducts(categoryIdEvent);
    };

    const handleProductNameChange = (e) => {
        const value = e.target.value;
        if (!value) {
            setProductNameError("Product name cannot be empty.");
        } else {
            setProductNameError("");
        }
        setSelectedProductId(value);
        setSlot(prevSlot => ({
            ...prevSlot,
            productId: value
        }));
    };


    const handleQuantityChange = (e) => {
        const value = e.target.value;
        if (value < 0) {
            setQuantityError("Quantity cannot be negative.");
        } else if (value > totalSlot) {
            setQuantityError("Quantity should be less than or equal to total slots in machine. Max quantity is " + totalSlot);
        } else {
            setQuantityError("");
        }
        handleChange('quantity', value);
    };

    const saveChangeSlot = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (isFormValid) {
            setLoading(true);
            let reqBody = JSON.stringify({
                MachineId: Number(slot.machineId),
                ProductId: Number(selectedProductId),
                SlotNo: slot.slotNo,
                InvQty: Number(slot.quantity),
            });
            simplePostCall(ApiConfig.UPDATE_PRODUCT_INTO_MACHINE, reqBody).then((res) => {
                setLoading(false);
                if (res.success) {
                    notifySuccess(res.message);
                    setShowChangeModal(false);
                    getProductList();
                } else {
                    notifyError(res.message);
                }
            }).catch(err => console.log(err));
        }
    };

    const validateForm = () => {
        if (!selectedProductId || slot.quantity > totalSlot || quantityError || productNameError) {
            setIsFormValid(false);
        } else {
            setIsFormValid(true);
        }
    };

    const getProductImageSrc = (product) => {
        if (machineId) {
            if (product && product.productId) {
                return product.productImage || noImage
            }
            return noProduct;
        }
        return product?.productImage || noImage;
    }


    return (<>
        <main id="cx-main" className={sidebar ? "dashboard-main" : "cx-active dashboard-main"}>
            {loading ? <Loading/> : (<>
                <h5 className="text-center mb-0">{machineId ? 'Vending Machine: ' : 'Virtual Machine: '}{vendingMachineName} {machineId ? `(${machineId})` : ''}</h5>
                {slots && slots.length > 0 ?(slots.map((slot, rowIndex) => {
                    return (<div key={rowIndex}
                                 ref={el => rowRefs.current[rowIndex] = el}
                                 className={`d-flex justify-content-center gap-1 pl-4 pr-4 overflow-auto mt-3 align-items-stretch`}
                                 style={{scrollbarWidth: 'none'}}>
                        {slot.slots.map((p, cardIndex) => {
                            return (<Card className={'mt-0'}
                                          key={cardIndex}
                                          style={{
                                              height: maxHeights[rowIndex] + 20 || 'auto',
                                              boxShadow: selectedProductIndex === cardIndex ? '0 10px 10px black' : 'none'
                                            }}>
                                <Card.Body className="pt-1 pb-1 d-flex flex-column">
                                    {machineId ? (
                                        <Card.Title className="h6 pr-0 pl-0 pt-1 pb-2 m-0">
                                            Cargo lane: {p.slotNo}
                                        </Card.Title>
                                    ) : (
                                        ''
                                    )}
                                    <div className={'pt-1 img-container'}>
                                        <Card.Img src={getProductImageSrc(p)}
                                                  variant="top" className="img m-0" style={{
                                            height: machineId ? '155px' : '180px',
                                            width: '100%',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px'
                                        }}/>
                                        <Button variant="primary" className="change-product-btn"
                                                onClick={() => handleChangeModalShow(p)}>
                                            Change
                                        </Button>
                                    </div>
                                    <Card.Text className="mt-auto d-flex flex-column" style={{textAlign: 'left', width: '100%'}}>
                                        <div className="row" ref={el => textRefs.current[rowIndex] = el}>
                                            <div className="col-12 text-wrap"
                                                 ref={el => {
                                                     if (!textRefs.current[rowIndex]) {
                                                         textRefs.current[rowIndex] = [];
                                                     }
                                                     textRefs.current[rowIndex][cardIndex] = el;
                                                 }}
                                                 style={{
                                                     height: maxTextHeights[rowIndex] || 'auto',
                                                     fontSize: 'medium'
                                                 }}>
                                                <span>{p.productName}</span>
                                            </div>
                                            <div className="col-12 d-flex justify-content-between mt-auto">
                                                <span style={{
                                                    fontWeight: 'bold', color: 'red', fontSize: 'smaller'
                                                }}>{p.price}</span>
                                                <span style={{
                                                    fontSize: 'smaller',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}>stock: {p.quantity + '/' + totalSlot}
                                                </span>
                                            </div>
                                        </div>
                                    </Card.Text>
                                </Card.Body>
                            </Card>);
                        })}
                    </div>);
                })): <h5 className={'text-center pt-2 text-danger'}>No product available</h5>}
                {/*<ProductForm*/}
                {/*    product={product}*/}
                {/*    handleChange={(key, val) => handleChange(key, val)}*/}
                {/*    updateSlot={updateSlot}*/}
                {/*    openModal={showUpdateModal}*/}
                {/*    handleOpenModal={() => {*/}
                {/*        setShowUpdateModal(false);*/}
                {/*        setSelectedProductIndex(-1);*/}
                {/*    }}*/}
                {/*/>*/}
            </>)}
        </main>
        <Modal show={showChangeModal} onHide={handleChangeModalClose}>
            <Modal.Header closeButton>
                <Modal.Title>Change Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={true}>
                    <Form.Group controlId="formSlotNo">
                        <Form.Label column={'sm'}>Slot No</Form.Label>
                        <Form.Control type="text" value={slot.slotNo} disabled/>
                    </Form.Group>
                    <Form.Group controlId="formCategory">
                        <Form.Label column={'sm'}>Category</Form.Label>
                        <Form.Select
                            value={selectedCategoryId || ""}
                            onChange={handleCategoryChange}
                            disabled={!machineId}
                        >
                            {categories?.map((category, index) => {
                                return (<option key={"category" + index} value={category.id}>
                                    {category.name}
                                </option>);
                            })}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group controlId="formProductName">
                        <Form.Label column={'sm'}>Product Name</Form.Label>
                        <Form.Select
                            value={selectedProductId || ""}
                            onChange={handleProductNameChange}
                            required
                            isInvalid={!!productNameError}
                            disabled={!machineId}
                        >
                            {products?.map((product, index) => {
                                return (<option key={"product" + index} value={product.product_id}>
                                    {product.product_name}
                                </option>);
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            {productNameError || "Please select a product name."}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formQuantity">
                        <Form.Label column={'sm'}>Quantity</Form.Label>
                        <Form.Control
                            type="number"
                            value={slot.quantity}
                            onChange={handleQuantityChange}
                            required
                            isInvalid={!!quantityError}
                        />
                        <Form.Control.Feedback type="invalid">
                            {quantityError || "Please enter a valid quantity."}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formPrice">
                        <Form.Label column={'sm'}>Price</Form.Label>
                        <Form.Control type="number" value={slot.price} disabled/>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleChangeModalClose}>
                    Close
                </Button>
                <Button variant="primary" type="submit" onClick={saveChangeSlot} disabled={!isFormValid}>
                    {loading ? <BtnLoader/> : "Save Changes"}
                </Button>
            </Modal.Footer>
        </Modal>
    </>);
}

export default ProductList;
